<template>
  <div class="markdown-content" v-html="compiledMarkdown" />
</template>

<script>
import { marked } from "marked";

// Configure marked options
marked.setOptions({
  gfm: true,
  breaks: true,
});

export default {
  name: "MarkdownDisplay",
  props: {
    markdown: {
      type: String,
      required: true,
    },
  },
  computed: {
    compiledMarkdown() {
      // Add proper spacing for list items if needed
      const formattedMarkdown = this.markdown
        .replace(/^•\s*/gm, "* ") // Replace bullet points with markdown list syntax
        .replace(/([^\n])\n(?!\n)/g, "$1  \n") // Add proper line breaks
        .trim();
      return marked(formattedMarkdown);
    },
  },
};
</script>

<style>
.markdown-content ul {
  list-style-type: disc;
  padding-left: 2em;
  margin: 1em 0;
}

.markdown-content li {
  margin: 0.5em 0;
}

.markdown-content p {
  margin: 1em 0;
  display: inline !important;
}
</style>
